import { createFileRoute, redirect } from "@tanstack/react-router";

import { HomePageRoute } from "../components/home/HomePageRoute";
import { SkillDetailPage } from "../components/skills/SkillDetailPage";

/**
 * `/$org/skills/$slug` — one skill: what it is for, how to use it in chat,
 * and its SKILL.md. A page inside Home, beside Home's sidebar.
 */
function SkillRouteView() {
  const { slug } = Route.useParams();
  return (
    <HomePageRoute>
      <SkillDetailPage key={slug} slug={slug} />
    </HomePageRoute>
  );
}

export const Route = createFileRoute("/$org/skills/$slug")({
  beforeLoad: async ({ context }) => {
    if (
      context.authGateState.status !== "authenticated" &&
      context.authGateState.status !== "hosted-static"
    ) {
      throw redirect({ to: "/pair", replace: true });
    }
  },
  component: SkillRouteView,
});
